export default {
  methods: {
    openZohoChat() {
      if ("$ZSIQChatWindow" in window) {
        window.$ZSIQChatWindow.openChatWindow();
      }
    },
    closeZohoChat() {
      if ("$ZSIQChatWindow" in window) {
        window.$ZSIQChatWindow.closeChatWindow();
      }
    },
  },
};
